<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('contacts')">Comercial</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Crear
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.nombres" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombres" />
          <text-input v-model="form.apellidos" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Apellidos" />
          <select-input v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Empresa">
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.nombre }}</option>
          </select-input>
          <text-input v-model="form.meta" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Meta" />
          <text-input v-model="form.venta_neto" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" label="Venta Neto" />
          <text-input v-model="form.cumplimiento" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" label="Cumplimiento" />
           <text-input v-model="form.estado" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" label="Estado" value="1"/>
         
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Comercial</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Crear Comercial' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
       proyecto: null,
        valor_total: null,
        reporte_diario_id: null,
        entrada: null,
        plazo: null,
        cuota: null,
        deuda: null,
        total: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('diariosdetalles.store'))
    },
  },
}
</script>
